import { createAction } from "@reduxjs/toolkit";
import type { UpdateProviderStudioBody } from "@shared-kernel/application/ports/provider/provider-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const updateProviderStudio = createApiThunk<void, UpdateProviderStudioBody>(
  "provider/studio/update",
  async (body, { extra: { providerRepository } }) => {
    await providerRepository!.updateStudio(body);
  },
);

export const resetUpdateProviderStudio = createAction("provider/studio/resetUpdate");
